import { adDestination } from "@adland/data";
import type { ActionAdapter } from "./types";

/** Open an external URL safely (no reverse-tabnabbing via `window.opener`). */
function openExternal(url: string): void {
  window.open(url, "_blank", "noopener,noreferrer");
}

/**
 * Plain-web action adapter. Carries no Farcaster dependency, so a build that
 * uses only this adapter (e.g. the web CDN bundle) ships none of the Mini App
 * SDK. Every ad type routes somewhere, except a token on a chain with no
 * DexScreener listing.
 *
 * Where each type goes now lives in `@adland/data` as `adDestination`, because
 * the server needs the same answer: a push notification about a new ad links
 * straight to it, and a second copy of "where does a cast go" is a second copy
 * that can disagree with this one.
 */
export const WebActionAdapter: ActionAdapter = {
  performAdAction(ad) {
    const url = adDestination(ad);
    if (url) {
      openExternal(url);
    } else {
      console.warn(
        `[@adland/react] WebActionAdapter has no web action for ad type "${ad.type}"`,
      );
    }
  },
  performEmptyAdAction(slot, chainId, baseLinkUrl) {
    openExternal(`${baseLinkUrl}/slots/${slot}?chain=${chainId}`);
  },
};
